module.exports = __webpack_public_path__ + "media/images/landing/en/create@2x-a8acdf6a1934244481958e0e38f9d023.png";